import type React from 'react';
import DynamicLineChart from '@/components/UI/Charts/DynamicLineChart/DynamicLineChart.tsx';
import DashboardCard from './DashboardCard';

interface TotalPaymentsProps {
  data: {
    total: number;
    percentChange: number;
    monthLabels: string[];
    chartCounts: number[];
  };
  className?: string;
}

const TotalPayments: React.FC<TotalPaymentsProps> = ({ data, className }) => {
  const { total, percentChange, monthLabels, chartCounts } = data;
  // Custom chart options for currency amounts
  const chartOptions = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value: any) => `$${value.toLocaleString()}`,
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context: any) => `$${context.parsed.y.toLocaleString()}`,
        },
      },
    },
  };

  return (
    <DashboardCard
      name='Total Payments'
      header={total.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      })}
      subHeader={`${percentChange >= 0 ? '+' : ''}${percentChange.toFixed(1)}% from last month`}
      className={className}
    >
      <div className='h-32 w-full'>
        <DynamicLineChart labels={monthLabels} data={chartCounts} options={chartOptions} />
      </div>
    </DashboardCard>
  );
};

export default TotalPayments;
